import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12z"
}), 'PersonalVideo');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PersonalVideo.js
// module id = 5326
// module chunks = 2